angular.module('impactx.securitydata').controller('SecurityDataCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'ToolbarService',
    SecurityDataController]);

function SecurityDataController($scope, $routeParams, dataGen, ToolbarService) {
    var self = this;
    self.catalogFilter = {name: ''};
    self.authorizationFilter = {name: ''};
    self.contractFilter = {name: ''};
    self.processFilter = {name: ''};
    self.resourceFilter = {id: ''};
    self.rightFilter = {right: ''};
    self.requestInProgress = true;
    self.visitedTabs = [false, false, false, false, false, false];

    $scope.$watch('selectedTab', function (newVal, oldVal) {
        if (!isUndefined(newVal) && newVal !== oldVal) {
            if (!self.visitedTabs[newVal]) {
                getData(newVal)
            }
        }
    });

    function setScopeData(resultData, tabIndex) {
        switch (tabIndex) {
            case 0:
                $scope.data.user = resultData.user;
                $scope.data.authorizations = resultData.authorizations;
                break;
            case 1:
                $scope.data.catalogs = resultData.catalogs;
                break;
            case 2:
                $scope.data.contracts = resultData.contracts;
                break;
            case 3:
                $scope.data.rights = resultData.rights;
                break;
            case 4:
                $scope.data.processes = resultData.processes;
                break;
            case 5:
                $scope.data.resources = resultData.resources;
                break;
        }
    }

    function getData(tabIndex) {
        self.requestInProgress = true;
        dataGen.getData({}, {userId: $routeParams.userId, tabIndex: tabIndex}, '/securitydata/view', null, true).then(function (result) {
            if (impactX.isDefined(result, 'data')) {
                setScopeData(result.data, tabIndex);
                self.visitedTabs[tabIndex] = true;
            }
            self.requestInProgress = false;
        });
    }

    dataGen.getData($scope, {}, '/securitydata/translations').then(function () {
        ToolbarService.setButtons([]);
        self.requestInProgress = false;
    });
}